import { Heading, Card } from "@aws-amplify/ui-react";

const QuestionDate = ({ heading, question, value, onChange, disabled }) => (
    <Card
        width="100%"
        maxWidth="800px"
        padding="2rem"
        variation="outlined"
        borderRadius="medium"
        boxShadow="2px 2px 3px 4px var(--amplify-colors-neutral-60)"
    >
        <Heading style={{
            color: '#88a6c7',
            fontSize: '2rem',
            fontWeight: 500
        }} marginBottom="1.5rem">{heading}</Heading>
        <Heading level={4} style={{ color: "#2a2f2e" }}>{question}</Heading>

        <label>
            <input
                type="date"
                value={value}
                isDisabled={disabled}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    padding: "0.5rem",
                    borderRadius: "0.25rem",
                    border: "1px solid #ccc",
                    maxWidth: "200px",
                    marginLeft: "1rem",
                    marginTop: "2rem"
                }}
            />
        </label>
    </Card>
);


export default QuestionDate;
